/**
 * Вычисляет остаток к оплате (total_price - payment_amount)
 * @param totalPrice - Общая стоимость заказа
 * @param paymentAmount - Уже оплаченная сумма
 * @returns Остаток к оплате (не может быть отрицательным)
 */
export const calculateRemainingPayment = (
  totalPrice: number | null | undefined,
  paymentAmount: number | null | undefined,
): number => {
  const total = totalPrice ?? 0
  const paid = paymentAmount ?? 0

  return Math.max(0, total - paid)
}
